Core.SubRouter = Backbone.SubRoute.extend({

    execute: function(callback, args, name) {
        debug.log('subroute', name);
        return app.router.execute(callback, args, name, this);
    },

    fallback: function() {
        return app.router.fallback();
    },
});